import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import state from './state';
import mutations from './mutations';
// Modules
/* eslint-disable import/no-cycle */
import config from './modules/config';
import device from './modules/device';
import file from './modules/file';
import gembaWalks from './modules/gemba-walks';
import jiraIssues from './modules/jira-issues';
import language from './modules/language';
import meeting from './modules/meeting';
import navigation from './modules/navigation';
import notifications from './modules/notifications';
import problem from './modules/problem';
import shizenStats from './modules/shizen-stats';
import socket from './modules/socket';
import vitality from './modules/vitality';
/* eslint-enable import/no-cycle */

const debug = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);

const modulesInitialState = {
  config: Object.assign({}, config.state),
  device: Object.assign({}, device.state),
  file: Object.assign({}, file.state),
  gembaWalks: Object.assign({}, gembaWalks.state),
  jiraIssues: Object.assign({}, jiraIssues.state),
  language: Object.assign({}, language.state),
  meeting: Object.assign({}, meeting.state),
  navigation: Object.assign({}, navigation.state),
  notifications: Object.assign({}, notifications.state),
  problem: Object.assign({}, problem.state),
  shizenStats: Object.assign({}, shizenStats.state),
  socket: Object.assign({}, socket.state),
  vitality: Object.assign({}, vitality.state),
};

const rootInitialState = {
  ...state,
};

export default new Vuex.Store({
  modules: {
    config,
    device,
    file,
    gembaWalks,
    jiraIssues,
    language,
    meeting,
    navigation,
    notifications,
    problem,
    socket,
    vitality,
    shizenStats,
  },
  actions,
  getters,
  state,
  mutations: {
    ...mutations,
    /** Reset the whole state to its initial value */
    resetState(rootState) {
      const { socket: { credentials, reconnectionTimeoutId, socket: socketConn }, jwt } = rootState;
      // Close the socket
      clearTimeout(reconnectionTimeoutId);
      if (socketConn) {
        socketConn.onclose = null;
        socketConn.close();
      }

      // Delete all non-module entry in the state
      Object.keys(rootState).forEach((key) => {
        if (!modulesInitialState[key]) {
          Vue.delete(rootState, key);
        }
      });
      // Re-set initial state values
      Object.keys(rootInitialState).forEach((key) => {
        Vue.set(rootState, key, rootInitialState[key]);
      });
      rootState.jwt = jwt;

      // Do the same for each state module
      Object.keys(modulesInitialState).forEach((moduleKey) => {
        if (modulesInitialState[moduleKey]) {
          Object.keys(rootState[moduleKey]).forEach((key) => {
            Vue.delete(rootState[moduleKey], key);
          });
          Object.keys(modulesInitialState[moduleKey]).forEach((key) => {
            Vue.set(rootState[moduleKey], key, modulesInitialState[moduleKey][key]);
          });
        }
      });
      rootState.socket.credentials = credentials;
    },
  },
  strict: debug,
});
